module.exports = __webpack_public_path__ + "static/media/Contacts_Screen.af8a6c1e.png";